<template>
  <div class="content-wrapper">
    <div class="editor-container">
      <div class="editor-card">
        <Toolbar 
          class="beauty-toolbar" 
          mode="simple" 
          :editor="editor" 
          :defaultConfig="toolbarConfig" 
        />
        <Editor 
          class="beauty-editor" 
          v-model="html" 
          :defaultConfig="editorConfig" 
          @onChange="onChange" 
          @onCreated="onCreated" 
          @onFocus="handleFocus" 
        />
      </div>
    </div>
    
    <el-dialog 
      title="插入公式" 
      width="65%" 
      append-to-body 
      :visible.sync="dialogVisible" 
      :before-close="handleClose"
      :fullscreen="isMobileDevice"
      class="beauty-dialog drag-limited-dialog"
      :class="{ 'mobile-fullscreen': isMobileDevice }"
      @open="onDialogOpen"
      @closed="onDialogClosed"
    >
      <formula-panel v-if="dialogVisible"></formula-panel>
      <span slot="footer" class="dialog-footer">
        <el-button class="beauty-btn cancel-btn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="beauty-btn confirm-btn" type="primary" @click="handleInsertFormula">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { Boot } from "@wangeditor/editor";
import pubsub from "pubsub-js";
import formulaPanel from "./formula/index.vue";
import drawPanel from "./draw/index.vue";
import kityformula from "@/components/js/formula";
import roughPaper from "@/components/js/draw";
import formulaModule from "@wangeditor/plugin-formula";
import "@wangeditor/editor/dist/css/style.css";

export default {
  name: "MyEditor",
  components: { Editor, Toolbar, formulaPanel, drawPanel },
  emits: ["fullscreen-change"],
  props: {
    answerHtml: String,
    formulaColor: {
      type: String,
      default: 'rgb(4, 247, 24)'
    }
  },
  data() {
    return {
      html: "",
      editor: null,
      dialogVisible: false,
      drawShow: false,
      timer: null,
      dragEnabled: false,
      dragStartX: 0,
      dragStartY: 0,
      initialLeft: 0,
      initialTop: 0,
      dialogElement: null,
      headerElement: null,
      dragHandler: null,
      resizeHandler: null,
      isMobileDevice: false,
      _iframeCleanups: null,
      _iframeObserver: null,
      toolbarConfig: {
        insertKeys: {
          index: 0,
          keys: ["kityFormula"],
        },
        excludeKeys: [
          "bold", "underline", "italic", "through", "code", "sub", "sup",
          "clearStyle", "color", "bgColor", "fontSize", "fontFamily",
          "indent", "delIndent", "justifyLeft", "justifyRight", "justifyCenter",
          "justifyJustify", "lineHeight", "group-image", "insertImage",
          "deleteImage", "editImage", "viewImageLink", "imageWidth30",
          "imageWidth50", "imageWidth100", "divider", "emotion", "insertLink",
          "editLink", "unLink", "viewLink", "codeBlock", "blockquote",
          "headerSelect", "header1", "header2", "header3", "header4", "header5",
          "todo", "bulletedList", "numberedList", "insertTable", "deleteTable",
          "insertTableRow", "deleteTableRow", "insertTableCol", "deleteTableCol",
          "tableHeader", "tableFullWidth", "insertVideo", "uploadVideo",
          "editVideoSize", "uploadImage", "codeSelectLang",
        ],
      },
      editorConfig: {
        placeholder: "✨ 在这里输入答案或详解...",
        MENU_CONF: {},
        hoverbarKeys: {
          text: { menuKeys: [] },
          image: { menuKeys: [] },
        },
      },
    };
  },
  methods: {
    checkMobile() {
      const isWidthMobile = window.innerWidth <= 768;
      const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      this.isMobileDevice = isWidthMobile || (hasTouchScreen && window.innerWidth <= 1024);
      return this.isMobileDevice;
    },
    subscribeSend() {
      pubsub.subscribe("getEditorText", (name, data) => {
        let { question, submitAnswer } = data;
        const editor = this.editor;
        if (editor == null) return;
        let htmlString = editor.getHtml();
        let content = this.extractContent(htmlString);
        question.answerHtml = htmlString;
        question.userAnswer = content;
      });
    },
    handleOpen() {
      this.editorFormulaMenuBtn = document.querySelector('[data-menu-key="kityFormula"]');
      this.handleFormulaMenuClick = () => {
        this.dialogVisible = true;
        this.drawShow = false;
      };
      this.editorFormulaMenuBtn.addEventListener("click", this.handleFormulaMenuClick);
      this.editor.setHtml(this.answerHtml);
    },
    handleDraw() {
      this.editorDrawMenuBtn = document.querySelector('[data-menu-key="roughPaper"]');
      this.handleDrawMenuClick = () => {
        this.drawShow = !this.drawShow;
      };
      this.editorDrawMenuBtn.addEventListener("click", this.handleDrawMenuClick);
    },
    parseColorToRgb(color) {
      const temp = document.createElement('div');
      temp.style.color = color;
      document.body.appendChild(temp);
      const computedColor = getComputedStyle(temp).color;
      document.body.removeChild(temp);
      const match = computedColor.match(/[\d\.]+/g);
      if (match && match.length >= 3) {
        return {
          r: parseInt(match[0]),
          g: parseInt(match[1]),
          b: parseInt(match[2])
        };
      }
      return { r: 0, g: 210, b: 210 };
    },
    recolorFormulaImage(imgSrc) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            const { r: targetR, g: targetG, b: targetB } = this.parseColorToRgb(this.formulaColor);
            for (let i = 0; i < data.length; i += 4) {
              const r = data[i];
              const g = data[i + 1];
              const b = data[i + 2];
              const a = data[i + 3];
              if (a > 0 && (r < 240 || g < 240 || b < 240)) {
                data[i] = targetR;
                data[i + 1] = targetG;
                data[i + 2] = targetB;
              }
            }
            ctx.putImageData(imageData, 0, 0);
            const newSrc = canvas.toDataURL();
            resolve(newSrc);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = (err) => reject(err);
        img.src = imgSrc;
      });
    },
    async handleInsertFormula() {
      try {
        const iframe = document.getElementById("inputIFrameId");
        if (!iframe || !iframe.contentWindow) {
          console.error("公式编辑器 iframe 未找到");
          this.dialogVisible = false;
          return;
        }
        const kfe = iframe.contentWindow.kfe;
        if (!kfe) {
          console.error("KityFormulaEditor 实例未就绪");
          this.dialogVisible = false;
          return;
        }
        kfe.execCommand("get.image.data", async (data) => {
          if (!data || !data.img) {
            console.error("未获取到公式图片数据");
            this.dialogVisible = false;
            return;
          }
          const latex = kfe.execCommand("get.source") || "";
          try {
            const coloredSrc = await this.recolorFormulaImage(data.img);
            const formulaNode = {
              style: "vertical-align: middle; display: inline-block;",
              type: "image",
              alt: latex,
              src: coloredSrc,
              children: [{ text: "" }],
            };
            this.editor.insertNode(formulaNode);
          } catch (err) {
            console.error("公式图片着色失败，使用原始图片", err);
            const formulaNode = {
              style: "vertical-align: middle; display: inline-block;",
              type: "image",
              alt: latex,
              src: data.img,
              children: [{ text: "" }],
            };
            this.editor.insertNode(formulaNode);
          } finally {
            this.dialogVisible = false;
          }
        });
      } catch (error) {
        console.error("插入公式出错", error);
        this.dialogVisible = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
      editor.on('fullScreen', () => {
        this.$emit('fullscreen-change', true);
      });
      editor.on('unFullScreen', () => {
        this.$emit('fullscreen-change', false);
      });
    },
    onChange(editor) {},
    handleFocus(editor) {},
    printEditorHtml() {
      const editor = this.editor;
      if (editor == null) return;
      return this.extractContent(editor.getHtml());
    },
    clearEditorHtml() {
      const editor = this.editor;
      if (editor == null) return;
      editor.clear();
    },
    extractContent(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const elements = doc.body.children;
      let content = "";
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (el.tagName === "P") {
          for (let j = 0; j < el.childNodes.length; j++) {
            const child = el.childNodes[j];
            if (child.tagName === "IMG") {
              let latex = child.getAttribute("alt");
              if (latex) {
                latex = latex.replaceAll("/", "//");
                content += "$" + latex + "$ ";
              }
            } else {
              content += child.textContent;
            }
          }
          content += "\n\r";
        }
      }
      return content;
    },
    extractDisplayContent(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const elements = doc.body.children;
      let content = "";
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (el.tagName === "P") {
          for (let j = 0; j < el.childNodes.length; j++) {
            const child = el.childNodes[j];
            if (child.tagName === "IMG") {
              const latex = child.getAttribute("src");
              content += latex;
            } else {
              content += child.textContent;
            }
          }
          content += "\n";
        }
      }
      return content;
    },
    getDeepActiveElement() {
      let active = document.activeElement;
      while (active && active.shadowRoot && active.shadowRoot.activeElement) {
        active = active.shadowRoot.activeElement;
      }
      if (active && active.tagName === 'IFRAME' && active.contentDocument) {
        const iframeActive = active.contentDocument.activeElement;
        if (iframeActive && iframeActive !== active.contentDocument.body) {
          return iframeActive;
        }
      }
      return active;
    },
    getScrollContainer() {
      if (!this.dialogVisible) return null;
      const dialog = document.querySelector('.mobile-fullscreen .el-dialog');
      if (!dialog) return null;
      return dialog.querySelector('.el-dialog__body');
    },
    scrollToElement(element) {
      if (!element || !this.isMobileDevice || !this.dialogVisible) return;
      const scrollContainer = this.getScrollContainer();
      if (!scrollContainer) return;
      requestAnimationFrame(() => {
        try {
          const containerRect = scrollContainer.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();
          const relativeTop = elementRect.top - containerRect.top + scrollContainer.scrollTop;
          const relativeBottom = elementRect.bottom - containerRect.top + scrollContainer.scrollTop;
          const containerScrollTop = scrollContainer.scrollTop;
          const containerHeight = containerRect.height;
          const elementHeight = elementRect.height;
          const topOffset = 20;
          const bottomOffset = 60;
          let targetScrollTop = null;
          if (relativeTop - topOffset < containerScrollTop) {
            targetScrollTop = Math.max(0, relativeTop - topOffset);
          } else if (relativeBottom + bottomOffset > containerScrollTop + containerHeight) {
            targetScrollTop = relativeBottom + bottomOffset - containerHeight;
          }
          if (targetScrollTop !== null) {
            scrollContainer.scrollTo({
              top: targetScrollTop,
              behavior: 'smooth'
            });
          }
        } catch (err) {
          console.warn('滚动到元素失败:', err);
        }
      });
    },
    handleFocusIn(e) {
      if (!this.isMobileDevice || !this.dialogVisible) return;
      setTimeout(() => {
        const activeElement = this.getDeepActiveElement();
        if (activeElement && this.isElementInsideDialog(activeElement)) {
          this.scrollToElement(activeElement);
        }
      }, 100);
    },
    handleResizeForKeyboard() {
      if (!this.isMobileDevice || !this.dialogVisible) return;
      setTimeout(() => {
        const activeElement = this.getDeepActiveElement();
        if (activeElement && this.isElementInsideDialog(activeElement)) {
          this.scrollToElement(activeElement);
        }
      }, 50);
    },
    isElementInsideDialog(element) {
      const dialog = document.querySelector('.mobile-fullscreen .el-dialog');
      if (!dialog) return false;
      return dialog.contains(element);
    },
    setupIframeFocusHandler(iframe) {
      if (!iframe || !iframe.contentDocument) return;
      try {
        const iframeDoc = iframe.contentDocument;
        if (iframe.__keyboardHandlerAttached) return;
        iframe.__keyboardHandlerAttached = true;
        const handleIframeFocusIn = () => {
          setTimeout(() => {
            const activeInIframe = iframe.contentDocument.activeElement;
            if (activeInIframe && activeInIframe !== iframe.contentDocument.body) {
              this.scrollToElement(activeInIframe);
            }
          }, 100);
        };
        iframeDoc.addEventListener('focusin', handleIframeFocusIn);
        if (!this._iframeCleanups) this._iframeCleanups = [];
        this._iframeCleanups.push(() => {
          iframeDoc.removeEventListener('focusin', handleIframeFocusIn);
          iframe.__keyboardHandlerAttached = false;
        });
      } catch (err) {
        console.warn('无法访问 iframe 内容（可能跨域）:', err);
      }
    },
    bindAllIframesFocus() {
      if (!this.dialogVisible) return;
      const dialog = document.querySelector('.mobile-fullscreen .el-dialog');
      if (!dialog) return;
      const iframes = dialog.querySelectorAll('iframe');
      iframes.forEach(iframe => {
        if (iframe.contentDocument) {
          this.setupIframeFocusHandler(iframe);
        } else {
          iframe.addEventListener('load', () => {
            this.setupIframeFocusHandler(iframe);
          });
        }
      });
    },
    initMobileKeyboardHandler() {
      if (!this.isMobileDevice || !this.dialogVisible) return;
      this.cleanupMobileKeyboardHandler();
      document.addEventListener('focusin', this.handleFocusIn);
      window.addEventListener('resize', this.handleResizeForKeyboard);
      setTimeout(() => {
        this.bindAllIframesFocus();
      }, 200);
      const dialog = document.querySelector('.mobile-fullscreen .el-dialog');
      if (dialog && !this._iframeObserver) {
        this._iframeObserver = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(node => {
                if (node.nodeName === 'IFRAME') {
                  this.setupIframeFocusHandler(node);
                } else if (node.querySelectorAll) {
                  node.querySelectorAll('iframe').forEach(iframe => {
                    this.setupIframeFocusHandler(iframe);
                  });
                }
              });
            }
          }
        });
        this._iframeObserver.observe(dialog, { childList: true, subtree: true });
      }
    },
    cleanupMobileKeyboardHandler() {
      document.removeEventListener('focusin', this.handleFocusIn);
      window.removeEventListener('resize', this.handleResizeForKeyboard);
      if (this._iframeCleanups) {
        this._iframeCleanups.forEach(cleanup => cleanup());
        this._iframeCleanups = [];
      }
      if (this._iframeObserver) {
        this._iframeObserver.disconnect();
        this._iframeObserver = null;
      }
    },
    resetDialogPosition() {
      if (this.isMobileDevice || !this.dialogElement) return;
      const dialogRect = this.dialogElement.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      let left = (windowWidth - dialogRect.width) / 2;
      let top = Math.max(20, (windowHeight - dialogRect.height) / 2);
      left = Math.max(0, Math.min(left, windowWidth - dialogRect.width));
      top = Math.max(0, Math.min(top, windowHeight - dialogRect.height));
      this.dialogElement.style.position = 'fixed';
      this.dialogElement.style.left = `${left}px`;
      this.dialogElement.style.top = `${top}px`;
      this.dialogElement.style.margin = '0';
      this.dialogElement.style.transform = 'none';
    },
    enforceDialogBounds() {
      if (this.isMobileDevice || !this.dialogElement) return;
      const rect = this.dialogElement.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      let newLeft = parseFloat(this.dialogElement.style.left) || rect.left;
      let newTop = parseFloat(this.dialogElement.style.top) || rect.top;
      const minLeft = 0;
      const minTop = 0;
      const maxLeft = windowWidth - rect.width;
      const maxTop = windowHeight - rect.height;
      newLeft = Math.min(Math.max(newLeft, minLeft), maxLeft);
      newTop = Math.min(Math.max(newTop, minTop), maxTop);
      if (newLeft !== rect.left) {
        this.dialogElement.style.left = `${newLeft}px`;
      }
      if (newTop !== rect.top) {
        this.dialogElement.style.top = `${newTop}px`;
      }
    },
    onDragMove(e) {
      if (!this.dragEnabled || this.isMobileDevice) return;
      e.preventDefault();
      let clientX, clientY;
      if (e.type === 'mousemove') {
        clientX = e.clientX;
        clientY = e.clientY;
      } else if (e.type === 'touchmove') {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
        e.preventDefault();
      } else {
        return;
      }
      const dx = clientX - this.dragStartX;
      const dy = clientY - this.dragStartY;
      let newLeft = this.initialLeft + dx;
      let newTop = this.initialTop + dy;
      if (this.dialogElement) {
        const rect = this.dialogElement.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const minLeft = 0;
        const minTop = 0;
        const maxLeft = windowWidth - rect.width;
        const maxTop = windowHeight - rect.height;
        newLeft = Math.min(Math.max(newLeft, minLeft), maxLeft);
        newTop = Math.min(Math.max(newTop, minTop), maxTop);
      }
      this.dialogElement.style.left = `${newLeft}px`;
      this.dialogElement.style.top = `${newTop}px`;
    },
    onDragEnd() {
      if (!this.dragEnabled) return;
      this.dragEnabled = false;
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
      document.removeEventListener('touchmove', this.onDragMove);
      document.removeEventListener('touchend', this.onDragEnd);
      document.body.style.userSelect = '';
      this.enforceDialogBounds();
    },
    onDragStart(e) {
      if (this.isMobileDevice || !this.dialogElement || !this.headerElement) return;
      let target = e.target;
      let isHeader = false;
      while (target && target !== this.dialogElement) {
        if (target.classList && target.classList.contains('el-dialog__header')) {
          isHeader = true;
          break;
        }
        target = target.parentNode;
      }
      if (!isHeader) return;
      e.preventDefault();
      let clientX, clientY;
      if (e.type === 'mousedown') {
        clientX = e.clientX;
        clientY = e.clientY;
      } else if (e.type === 'touchstart') {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        return;
      }
      this.dragStartX = clientX;
      this.dragStartY = clientY;
      const rect = this.dialogElement.getBoundingClientRect();
      this.initialLeft = rect.left;
      this.initialTop = rect.top;
      this.dragEnabled = true;
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
      document.addEventListener('touchmove', this.onDragMove, { passive: false });
      document.addEventListener('touchend', this.onDragEnd);
      document.body.style.userSelect = 'none';
    },
    initDragControl() {
      if (!this.dialogVisible) return;
      if (this.isMobileDevice) {
        this.removeDragListeners();
        return;
      }
      this.$nextTick(() => {
        this.dialogElement = document.querySelector('.drag-limited-dialog .el-dialog');
        this.headerElement = document.querySelector('.drag-limited-dialog .el-dialog__header');
        if (!this.dialogElement || !this.headerElement) return;
        this.resetDialogPosition();
        this.removeDragListeners();
        this.headerElement.addEventListener('mousedown', this.onDragStart);
        this.headerElement.addEventListener('touchstart', this.onDragStart);
        if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = () => {
          if (this.dialogVisible && this.dialogElement && !this.isMobileDevice) {
            this.enforceDialogBounds();
          }
        };
        window.addEventListener('resize', this.resizeHandler);
      });
    },
    removeDragListeners() {
      if (this.headerElement) {
        this.headerElement.removeEventListener('mousedown', this.onDragStart);
        this.headerElement.removeEventListener('touchstart', this.onDragStart);
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = null;
      }
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
      document.removeEventListener('touchmove', this.onDragMove);
      document.removeEventListener('touchend', this.onDragEnd);
      this.dragEnabled = false;
    },
    updateMobileAndDrag() {
      const wasMobile = this.isMobileDevice;
      const nowMobile = this.checkMobile();
      if (wasMobile !== nowMobile && this.dialogVisible) {
        this.removeDragListeners();
        if (nowMobile) {
          if (this.dialogElement) {
            this.dialogElement.style.left = '';
            this.dialogElement.style.top = '';
            this.dialogElement.style.position = '';
          }
          this.initMobileKeyboardHandler();
        } else {
          this.cleanupMobileKeyboardHandler();
          this.resetDialogPosition();
        }
        this.initDragControl();
      } else {
        this.checkMobile();
        if (!this.isMobileDevice && this.dialogVisible) {
          this.enforceDialogBounds();
        } else if (this.isMobileDevice && this.dialogVisible) {
          this.initMobileKeyboardHandler();
        }
      }
    },
    onDialogOpen() {
      this.checkMobile();
      this.initDragControl();
      if (this.isMobileDevice) {
        this.initMobileKeyboardHandler();
      }
    },
    onDialogClosed() {
      this.removeDragListeners();
      this.cleanupMobileKeyboardHandler();
      this.dialogElement = null;
      this.headerElement = null;
    },
  },
  created() {
    Boot.registerMenu(kityformula);
    Boot.registerMenu(roughPaper);
    Boot.registerModule(formulaModule);
    this.checkMobile();
    window.addEventListener('resize', this.updateMobileAndDrag);
    this._iframeCleanups = [];
    this._iframeObserver = null;
  },
  mounted() {
    this.subscribeSend();
    this.timer = setTimeout(() => {
      this.handleOpen();
      this.handleDraw();
    }, 0);
  },
  beforeDestroy() {
    this.editorFormulaMenuBtn &&
      this.editorFormulaMenuBtn.removeEventListener("click", this.handleFormulaMenuClick);
    this.editorDrawMenuBtn &&
      this.editorDrawMenuBtn.removeEventListener("click", this.handleDrawMenuClick);
    clearTimeout(this.timer);
    this.removeDragListeners();
    this.cleanupMobileKeyboardHandler();
    window.removeEventListener('resize', this.updateMobileAndDrag);
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy();
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  --editor-border-radius: 16px;
  --editor-card-shadow: none;
  --editor-hover-shadow: none;
  --toolbar-bg: transparent;
  --editor-bg: transparent;
  --border-light: rgba(0, 0, 0, 0.08);
  --accent-color: #4361ee;
  --accent-hover: #3a56d4;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --placeholder-color: #94a3b8;
}

@media (prefers-color-scheme: dark) {
  .content-wrapper {
    --toolbar-bg: transparent;
    --editor-bg: transparent;
    --border-light: rgba(255, 255, 255, 0.08);
    --text-primary: #f1f5f9;
    --text-secondary: #cbd5e1;
    --placeholder-color: #64748b;
  }
}

.editor-container {
  max-width: 1000px;
  margin: 24px auto;
  padding: 0 16px;
}

.editor-card {
  border-radius: var(--editor-border-radius);
  background: transparent;
  box-shadow: none;
  transition: none;
  backdrop-filter: none;
  overflow: hidden;
  border: none;
}

:deep(.beauty-toolbar) {
  border-bottom: none !important;
  background: transparent !important;
  backdrop-filter: none;
  padding: 6px 12px;
  
  .w-e-bar {
    background: transparent !important;
  }
  
  .w-e-bar-item {
    button {
      border-radius: 10px;
      transition: all 0.2s ease;
      margin: 0 2px;
      
      &:hover {
        background-color: rgba(67, 97, 238, 0.1) !important;
        transform: translateY(-1px);
      }
    }
    
    svg {
      fill: var(--text-primary);
      transition: fill 0.2s;
    }
  }
  
  [data-menu-key="kityFormula"] {
    button {
      background: rgba(67, 97, 238, 0.1);
      border-radius: 12px;
      
      &:hover {
        background: rgba(67, 97, 238, 0.2);
      }
    }
  }
}

:deep(.beauty-editor) {
  border-radius: 0 0 var(--editor-border-radius) var(--editor-border-radius);
  background-color: transparent !important;
  
  .w-e-text-container {
    background-color: transparent !important;
    border-radius: 0 0 var(--editor-border-radius) var(--editor-border-radius);
    
    [data-slate-editor] {
      padding: 24px 28px;
      font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
      font-size: 15px;
      line-height: 1.6;
      color: var(--text-primary);
      background: transparent !important;
      
      caret-color: rgb(241, 4, 36);
      text-shadow: 0 0 0.5px rgba(218, 4, 4, 0.8);
      
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      
      &::-webkit-scrollbar-track {
        background: var(--border-light);
        border-radius: 10px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: var(--text-secondary);
        border-radius: 10px;
        
        &:hover {
          background: var(--accent-color);
        }
      }
      
      &:before {
        color: var(--placeholder-color) !important;
        font-style: italic;
        font-weight: 400;
      }
      
      img {
        margin: 0 2px;
        height: auto;
        max-height: 48px;
        vertical-align: middle;
        display: inline-block;
        transition: transform 0.2s ease, filter 0.2s ease;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
        border-radius: 6px;
        
        &:hover {
          transform: scale(1.02);
          filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
        }
      }
      
      p {
        margin: 0 0 0.75em 0;
        line-height: 1.6;
      }
    }
  }
  
  &:focus-within {
    .w-e-text-container {
      box-shadow: 0 0 0 2px rgba(0, 174, 255, 0.5);
    }
  }
}

// 公式弹窗外框圆角优化（强制生效，桌面端48px大圆角，移动端全屏时无圆角）
:deep(.beauty-dialog) {
  // 桌面端（非全屏）强制圆角 + 裁剪溢出
  &:not(.mobile-fullscreen) .el-dialog {
    border-radius: 48px !important;
    overflow: hidden !important;      // 关键：裁剪内部子元素
    box-shadow: 0 30px 50px rgba(0, 0, 0, 0.25);
    
    .el-dialog__header {
      border-radius: 48px 48px 0 0 !important;
    }
    .el-dialog__footer {
      border-radius: 0 0 48px 48px !important;
    }
  }
  
  // 移动端全屏时无圆角
  &.mobile-fullscreen .el-dialog {
    border-radius: 0 !important;
    overflow: visible !important;
  }
}

:deep(.kf-editor-edit-area) {
  width: 100%;
  background: transparent;
  border-radius: 16px;
  border: 1px solid var(--border-light);
  min-height: 300px;
  
  @media (max-width: 768px) {
    min-height: 250px;
    border-radius: 12px;
  }
}

:deep(.kf-editor-toolbar) {
  @media (max-width: 768px) {
    flex-wrap: wrap;
    button, .kf-toolbar-item {
      min-width: 44px;
      min-height: 44px;
      margin: 2px;
    }
  }
}

:deep(.w-e-full-screen-container) {
  z-index: 1000;
  background: transparent;
  
  .beauty-toolbar {
    backdrop-filter: none;
    background: transparent !important;
  }
}

@media (max-width: 1023px) {
  .editor-container {
    padding: 0 12px;
    margin: 16px auto;
  }
  
  :deep(.beauty-editor) {
    .w-e-text-container [data-slate-editor] {
      padding: 16px 20px;
      font-size: 14px;
      
      img {
        max-height: 40px;
      }
    }
  }
}

@media (max-width: 480px) {
  :deep(.beauty-dialog) {
    .el-dialog__body {
      padding: 12px;
    }
    .beauty-btn {
      padding: 10px 12px;
      font-size: 14px;
    }
  }
  :deep(.kf-editor-edit-area) {
    min-height: 200px;
  }
}

/* 取消与确定按钮美化 */
.beauty-dialog {
  .beauty-btn {
    padding: 10px 28px !important;
    border-radius: 60px !important;
    font-weight: 600 !important;
    letter-spacing: 0.5px;
    transition: all 0.2s ease !important;
  }

  .cancel-btn {
    background: rgba(0, 0, 0, 0.05) !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    color: #4b5563 !important;
    box-shadow: none !important;

    &:hover {
      background: rgba(0, 0, 0, 0.1) !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05) !important;
    }
  }

  .confirm-btn {
    background: linear-gradient(135deg,rgb(67, 238, 195),rgb(58, 212, 117)) !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(67, 97, 238, 0.3) !important;
    color: white !important;

    &:hover {
      transform: translateY(-2px);
      background: linear-gradient(135deg,rgb(184, 212, 58),rgb(167, 194, 46)) !important;
      box-shadow: 0 8px 18px rgba(67, 97, 238, 0.4) !important;
    }

    &:active {
      transform: translateY(1px);
    }
  }
}

:deep(.kf-editor-edit-area) {
  border-radius: 20px !important;
  overflow: hidden;
}

/* ========== 移动端公式插入窗口专项优化 ========== */
@media (max-width: 768px) {
  .beauty-dialog.mobile-fullscreen {
    .el-dialog__body {
      padding: 12px !important;
      padding-bottom: env(safe-area-inset-bottom, 12px) !important;
      -webkit-overflow-scrolling: touch;
    }

    .formula-panel {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    :deep(.kf-editor-toolbar) {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 6px;
      padding: 8px 4px;
      background: transparent;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;

      button,
      .kf-toolbar-item {
        min-width: 44px;
        min-height: 44px;
        padding: 0 8px;
        margin: 0;
        font-size: 14px;
        border-radius: 22px;
        flex-shrink: 0;
      }
    }

    :deep(.kf-editor-edit-area) {
      width: 100%;
      min-height: 280px;
      height: auto;
      flex: 1;
      margin-top: 8px;
      border-radius: 16px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      font-size: 16px;
      padding: 12px;
      box-sizing: border-box;

      iframe,
      canvas {
        max-width: 100%;
        height: auto;
      }
    }

    :deep(.kf-tabs),
    :deep(.kf-symbol-panel) {
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      padding-bottom: 6px;

      .kf-tab,
      .kf-symbol-item {
        display: inline-block;
        min-width: 44px;
        text-align: center;
        padding: 8px 12px;
        font-size: 14px;
      }
    }
  }

  @media (max-width: 480px) {
    .beauty-dialog.mobile-fullscreen {
      .el-dialog__body {
        padding: 8px !important;
      }

      :deep(.kf-editor-edit-area) {
        min-height: 220px;
        font-size: 14px;
        padding: 8px;
      }

      :deep(.kf-editor-toolbar) {
        gap: 4px;
        button,
        .kf-toolbar-item {
          min-width: 40px;
          min-height: 40px;
          font-size: 12px;
        }
      }
    }
  }
}

@media (hover: none) and (pointer: coarse) {
  .beauty-dialog.mobile-fullscreen {
    button,
    .kf-toolbar-item,
    .el-button {
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      touch-action: manipulation;
    }
  }
}
</style>

<style lang="scss">
/* 全局样式，确保覆盖 Element UI 默认值 */
.drag-limited-dialog:not(.mobile-fullscreen) .el-dialog {
  border-radius: 36px !important;
  overflow: hidden !important;
}
.drag-limited-dialog.mobile-fullscreen .el-dialog {
  border-radius: 0 !important;
}
</style>